import {
  PERMISSIONS_ENUM,
  ROUTE_COTTON_ANALYTICAL,
  ROUTE_DOCS_AGRO_TECHNICAL_EVENTS,
  ROUTE_DOCS_LANDS,
  ROUTE_DOCS_MONITORING,
  ROUTE_DOCS_PROJECTS,
  ROUTE_DOCS_STEWARDSHIP,
  ROUTE_LOGIN,
  ROUTE_TEACHER_STUDENT,
  ROUTE_TEACHER_STUDENT_STAT,
} from '@/common/constants';
import AgroTechnicalEventsSingle from '@/features/agro-technical-events/components/single/AgroTechnicalEventsSingle.tsx';
import LandSingle from '@/features/lands/components/single/LandSingle.tsx';
import { MonitoringDistrict } from '@/features/monitoring/components/single/district/MonitoringDistrict.tsx';
import { FarmersWrapper } from '@/features/monitoring/components/single/farmer/Farmers.tsx';
import { Agrotechnical } from '@/features/monitoring/components/single/farmer/agrotechnical/Agrotechnical.tsx';
import { MonitoringRepublic } from '@/features/monitoring/components/single/republic/MonitoringRepublic.tsx';
import { ProjectSingle } from '@/features/projects/components/single/ProjectSingle.tsx';
import { StewardshipAgrotechEventList } from '@/features/stewardship/components/single/agrotech-events/StewardshipAgrotechEventList.tsx';
import { StewardshipDistrictList } from '@/features/stewardship/components/single/district-list/StewardshipDistrictList.tsx';
import { StewardshipProjectDetail } from '@/features/stewardship/components/single/project/StewardshipProjectDetail.tsx';
import { StewardshipProjectWrapper } from '@/features/stewardship/components/single/project/StewardshipProjectWrapper.tsx';
import { StewardshipRegionList } from '@/features/stewardship/components/single/region-list/StewardshipRegionList.tsx';
import { StewardshipEmployeesList } from '@/features/stewardship/components/single/responsible-employees/StewardshipEmployeesList.tsx';
import { TeacherStudentStatDistrict } from '@/features/teacher-student-stat/components/single/district/TeacherStudentStatDistrict.tsx';
import { TerritoryTeacherStatStudent } from '@/features/teacher-student-stat/components/single/employees/TerritoryTeacherStatStudents.tsx';
import { TeacherStudentStatRepublic } from '@/features/teacher-student-stat/components/single/republic/TeacherStudentStatRepublic.tsx';
import { TeacherStudentDistrict } from '@/features/teacher-student/components/single/district/TeacherStudentDistrict.tsx';
import { TerritoryTeacherStudent } from '@/features/teacher-student/components/single/employees/TerritoryTeacherStudents.tsx';
import { TeacherStudentRepublic } from '@/features/teacher-student/components/single/republic/TeacherStudentRepublic.tsx';
import { DefaultLayout, PrivateRoute } from '@/layouts';
import { AuthLayout } from '@/layouts/AuthLayout.tsx';
import AgroTechnicalEventsPage from '@/pages/agro-technical-events/AgroTechnicalEventsPage.tsx';
import CottonAnalyticalPage from '@/pages/cotton-analytical/CottonAnalyticalPage.tsx';
import LandPage from '@/pages/lands/LandPage.tsx';
import Monitoring from '@/pages/monitoring/Monitoring.tsx';
import ProjectPage from '@/pages/projects/ProjectPage.tsx';
import Stewardship from '@/pages/stewardship/Stewardship.tsx';
import { Navigate, RouteObject } from 'react-router-dom';
import { Auth } from '../features/auth/components/Auth.tsx';

export const routes = (): RouteObject[] => {
  return [
    {
      path: ROUTE_LOGIN,
      caseSensitive: true,
      element: <AuthLayout />,
      children: [
        {
          index: true,
          element: <Auth />,
        },
      ],
    },
    {
      path: '/:lang',
      caseSensitive: true,
      element: <DefaultLayout />,

      children: [
        {
          element: (
            <PrivateRoute
              permission={PERMISSIONS_ENUM.VIEW_LANDS}
              redirectPath="/"
            />
          ),
          children: [
            {
              path: ROUTE_DOCS_LANDS,
              element: <LandPage />,
              children: [
                { path: ':status', element: <></> },
                { path: ':status/:id', element: <LandSingle /> },
              ],
            },
            {
              path: ROUTE_DOCS_AGRO_TECHNICAL_EVENTS,
              element: <AgroTechnicalEventsPage />,
              children: [
                { path: ':status', element: <></> },
                {
                  path: ':status/:id',
                  element: <AgroTechnicalEventsSingle />,
                },
              ],
            },
          ],
        },
        {
          element: (
            <PrivateRoute
              permission={PERMISSIONS_ENUM.VIEW_PROJECTS}
              redirectPath="/"
            />
          ),
          children: [
            {
              path: ROUTE_DOCS_PROJECTS,
              element: <ProjectPage />,
              children: [{ path: ':id', element: <ProjectSingle /> }],
            },
          ],
        },
        {
          element: (
            <PrivateRoute
              permission={PERMISSIONS_ENUM.VIEW_STATISTICS}
              redirectPath="/"
            />
          ),
          children: [
            {
              path: ROUTE_DOCS_MONITORING,
              element: <Monitoring />,
              children: [
                { path: ':type', element: <MonitoringRepublic /> },
                { path: ':type/:region_id', element: <MonitoringDistrict /> },
                {
                  path: ':type/:region_id/:district_id',
                  element: <FarmersWrapper />,
                },
                {
                  path: ':type/:region_id/:district_id/farmers',
                  element: <FarmersWrapper />,
                  children: [{ path: ':id', element: <Agrotechnical /> }],
                },
              ],
            },
            {
              path: ROUTE_DOCS_STEWARDSHIP,
              element: <Stewardship />,
              children: [
                { index: true, element: <StewardshipRegionList /> },
                {
                  path: ':region_id',
                  element: <StewardshipDistrictList />,
                },
                {
                  path: ':region_id/:district_id',
                  element: <StewardshipEmployeesList />,
                },
                {
                  path: ':region_id/:district_id/:employee_id',
                  element: <StewardshipAgrotechEventList />,
                },
                {
                  path: ':region_id/:district_id/:employee_id/projects',
                  element: <StewardshipProjectWrapper />,
                  children: [
                    {
                      path: ':project_id',
                      element: <StewardshipProjectDetail />,
                    },
                  ],
                },
              ],
            },
            {
              path: ROUTE_COTTON_ANALYTICAL,
              element: <CottonAnalyticalPage />,
            },
          ],
        },
        {
          element: (
            <PrivateRoute
              permission={PERMISSIONS_ENUM.VIEW_STATISTICS}
              redirectPath="/"
            />
          ),
          children: [
            {
              path: ROUTE_TEACHER_STUDENT,
              children: [
                {
                  index: true,
                  element: <TeacherStudentRepublic />,
                },
                {
                  path: ':regionId',
                  children: [
                    {
                      index: true,
                      element: <TeacherStudentDistrict />,
                    },
                    {
                      path: ':districtId',
                      children: [
                        {
                          index: true,
                          element: <TerritoryTeacherStudent />,
                        },
                        {
                          path: `${ROUTE_DOCS_AGRO_TECHNICAL_EVENTS}/:masterId`,
                          element: <AgroTechnicalEventsPage />,
                          children: [
                            { path: ':status', element: <></> },
                            {
                              path: ':status/:id',
                              element: <AgroTechnicalEventsSingle />,
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: ROUTE_TEACHER_STUDENT_STAT,
              children: [
                {
                  index: true,
                  element: <TeacherStudentStatRepublic />,
                },
                {
                  path: ':regionId',
                  children: [
                    {
                      index: true,
                      element: <TeacherStudentStatDistrict />,
                    },
                    {
                      path: ':districtId',
                      children: [
                        {
                          index: true,
                          element: <TerritoryTeacherStatStudent />,
                        },
                        {
                          path: `${ROUTE_DOCS_AGRO_TECHNICAL_EVENTS}/:masterId`,
                          element: <AgroTechnicalEventsPage />,
                          children: [
                            { path: ':status', element: <></> },
                            {
                              path: ':status/:id',
                              element: <AgroTechnicalEventsSingle />,
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/uz" replace />,
    },
  ];
};
